<!-- <nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="data?.id ? 'Edit POC' : 'Add a New POC'"
  [nzMaskClosable]="false"
  (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="venueForm">
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Contact Person</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter contact person">
          <input
            nz-input
            formControlName="name"
            placeholder="Enter contact person"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Email</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid email">
          <input nz-input formControlName="email" placeholder="Enter email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Mobile Number</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <nz-input-group [nzAddOnBefore]="mobileCode">
            <ng-template #mobileCode>
              <nz-select
                formControlName="country_code"
                nzShowSearch
                nzAllowClear
                class="phone-select"
                nzPlaceHolder="Code"
              >
                @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option
                  [nzValue]="countryCode.id"
                  [nzLabel]="`${countryCode.code} (${countryCode.country_name})`"
                ></nz-option>
                }
              </nz-select>
            </ng-template>
            <input
              nz-input
              formControlName="mobile_number"
              placeholder="Enter mobile number"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">WhatsApp Number</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <nz-input-group [nzAddOnBefore]="whatsappCode">
            <ng-template #whatsappCode>
              <nz-select
                formControlName="country_code_whatsapp"
                nzShowSearch
                nzAllowClear
                class="phone-select"
                nzPlaceHolder="Code"
              >
                @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option
                  [nzValue]="countryCode.id"
                  [nzLabel]="`${countryCode.code} (${countryCode.country_name})`"
                ></nz-option>
                }
              </nz-select>
            </ng-template>
            <input
              nz-input
              formControlName="whatsapp_number"
              placeholder="Enter WhatsApp number"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Business Number</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <nz-input-group [nzAddOnBefore]="businessCode">
            <ng-template #businessCode>
              <nz-select
                formControlName="country_code_business"
                nzShowSearch
                nzAllowClear
                class="phone-select"
                nzPlaceHolder="Code"
              >
                @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option
                  [nzValue]="countryCode.id"
                  [nzLabel]="`${countryCode.code} (${countryCode.country_name})`"
                ></nz-option>
                }
              </nz-select>
            </ng-template>
            <input
              nz-input
              formControlName="business_number"
              placeholder="Enter business number"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!venueForm.valid"
      (click)="save()"
    >
      {{ data?.id ? "Update" : "Save" }}
    </button>
  </ng-template>
</nz-modal> -->


<nz-modal [(nzVisible)]="isVisible" [nzTitle]="data?.id ? 'Edit POC' : 'Add a New POC'" [nzMaskClosable]="false"
  (nzOnCancel)="handleCancel()" [nzFooter]="modalFooter">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="venueForm">

      <!-- Contact Person -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Contact Person</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter contact person">
          <input nz-input formControlName="name" placeholder="Enter contact person" />
        </nz-form-control>
      </nz-form-item>

      <!-- Email -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Email</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid email">
          <input nz-input formControlName="email" placeholder="Enter email" />
        </nz-form-control>
      </nz-form-item>

      <!-- Country Code -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Country Code</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select a country code">
          <nz-select formControlName="country_code" nzShowSearch nzAllowClear nzPlaceHolder="Select code">
            @for (countryCode of countryCodeList; track countryCode.id) {
            <nz-option [nzValue]="countryCode.id"
              [nzLabel]="`${countryCode.code} (${countryCode.country_name})`"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Mobile Number -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Mobile Number</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter mobile number">
          <input nz-input formControlName="mobile_number" placeholder="Enter mobile number" />
        </nz-form-control>
      </nz-form-item>

      <!-- WhatsApp Number -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7">WhatsApp Number</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <input nz-input formControlName="whatsapp_number" placeholder="Enter WhatsApp number" />
        </nz-form-control>
      </nz-form-item>

      <!-- Business Number -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7">Business Number</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <input nz-input formControlName="business_number" placeholder="Enter business number" />
        </nz-form-control>
      </nz-form-item>

    </form>
  </ng-container>

  <!-- Footer -->
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="!venueForm.valid" (click)="save()">
      {{ data?.id ? "Update" : "Save" }}
    </button>
  </ng-template>
</nz-modal>
